import { Button } from '@shared/models/wl_components/button.interface';

export const RESERVATION_DEFAULT_COLUMNS = [
  { name: 'Surname', key: 'origin.description', visible: true },
  { name: 'Booking Reference', key: 'firstName', visible: true },
  { name: 'Contact Number', key: 'overtaken', visible: true },
  { name: 'Journey', key: 'admin', visible: true },
  { name: 'Ticket Number', key: 'email', visible: true },
  //{ name: 'INFO', key: '', visible: true },
];

export const helpButton: Button = {
  type: 'secondary',
  text: $localize`Help`,
  frontIcon: 'info',
  size: 'small',
};

export const accountButtonConfig: Button = {
  type: 'primary',
  text: 'Current User',
  frontIcon: 'account_circle',
  backIcon: 'keyboard_arrow_down',
  size: 'small',
};
